module.exports = __webpack_public_path__ + "static/media/coming-soon.444a6231.png";